import React, { useState } from "react";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import DeviceInfo from "./DeviceInfo";
import DeviceLog from "./DeivceLog";
import DeviceAnalytic from "./device-analytic/DeviceAnalytic";
import DeviceNote from "./DeviceNote";
import DeviceEventHistory from "./DeviceEventHistory";

const DeviceDetail = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pimios_id } = useParams();
  console.log("Device ID:", pimios_id);
  const [activeTab, setActiveTab] = useState("Info");
  const deviceName = pimios_id?.split("-").slice(1).join("-");

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Info":
        return <DeviceInfo />;
      case "Logs":
        return <DeviceLog />;
      case "Analytics":
        return <DeviceAnalytic />;
      case "Notes":
        return <DeviceNote />;
      case "Events History":
        return <DeviceEventHistory />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Back Button and Header */}
      <Box className="flex mb-2 gap-x-2" sx={{ alignItems: "center" }}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6">Details for Device: {deviceName}</Typography>
      </Box>

      {/* Tab Buttons */}
      <Box className="flex gap-2 mb-2">
        {["Info", "Logs", "Analytics", "Notes", "Events History"].map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : "text.primary",
              }}
            >
              {tab}
            </Button>
          </Box>
        ))}
      </Box>

      {/* Active Tab Content */}
      {renderActiveTab()}
    </>
  );
};

export default DeviceDetail;
